import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UrlConstants } from 'src/app/_helpers/url-constants';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmpexpenseserviceService {

  private expenseAddedSource = new Subject<void>();
  productAdded$ = this.expenseAddedSource.asObservable();

  notifyExpenseAdded() {
    this.expenseAddedSource.next();
  }
  
  constructor(public httpClient:HttpService) { }

  getAllExpenseDetails(data:{},empId):any{
    return new Promise((resolve, reject) => {
      this.httpClient.call(data, UrlConstants.empgetAllexpense + empId , 'GET').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  addExpenseDetails(data:{},empId){
    return new Promise((resolve, reject) => {
      this.httpClient.call(data, UrlConstants.empaddexpense + empId ,  'POST').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  deleteExpense(data:{},expenseId){
    return new Promise((resolve, reject) => {
      this.httpClient.call(data, UrlConstants.empdeleteexpense + expenseId ,  'DELETE').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  GetExpenseByExpenseId(data:{},expenseId){
    return new Promise((resolve, reject) => {
      this.httpClient.call(data, UrlConstants.empgetByIdexpense + expenseId , 'GET').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
   
  }

  ExpenseUpdateByEmployeeId(data:{},empId){
    return new Promise((resolve, reject) => {
      this.httpClient.call(data, UrlConstants.updateexpenseById+ empId ,'PUT').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }
}
